<template>
  <v-container
    fluid
    style="min-height: 100vh; border-radius: 0; overflow: auto"
    :class="BeyondSelected ? 'otp' : ''"
  >
    <v-row
      align="center"
      class="fill-height"
      :class="{
        'justify-center': !BeyondSelected,
        'justify-left': BeyondSelected,
      }"
    >
      <v-col
        :cols="12"
        :sm="8"
        :md="6"
        :lg="5"
        :class="BeyondSelected ? 'beyond-margin' : ''"
      >
        <v-card rounded="0" :class="BeyondSelected ? 'clear' : 'cardspace'">
          <v-toolbar
            flat
            dense
            color="#005F95"
            class="d-flex justify-center align-center"
          >
            <div>
              <!-- Small to Large Screens -->
              <h3
                class="Login-Toolbar text-center"
                :style="{
                  fontSize: isSmall ? '11px' : isMedium ? '16px' : '18px',
                  padding: isSmall ? '50px' : '50px',
                }"
              >
                DINERS CLUB {{ product }} ONLINE APPLICATION
              </h3>
            </div>
          </v-toolbar>

          <v-container
            fluid
            style="border: 1px solid #ccc; border-radius: 0; padding: 16px"
          >
            <v-container fluid style="border-radius: 0; padding: 16px">
              <v-row>
                <v-col cols="12">
                  <h1 class="OTP-Tittle" style="text-align: center">
                    ENTER YOUR ONE-TIME PASSWORD (OTP):
                  </h1>
                </v-col>
              </v-row>

              <v-row justify="center" align="center">
                <v-col
                  cols="12"
                  md="12"
                  class="text-center d-flex justify-center"
                >
                  <v-text-field
                    v-for="(digit, index) in otp"
                    :key="index"
                    ref="otpRefs"
                    v-model="otp[index]"
                    maxlength="1"
                    class="otp-box"
                    density="compact"
                    hide-details
                    type="text"
                    variant="outlined"
                    @input="handleInput(index, $event)"
                    @keydown.delete="handleBackspace(index, $event)"
                  />
                </v-col>

                <!--************---If the OTP is not Expired---********** -->

                <v-col>
                  <!-- OTP Sent Message -->
                  <div v-if="!expired" class="text-center">
                    OTP sent to: [{{ maskedCell }}]
                  </div>

                  <!-- Resend OTP Link -->
                  <div v-else class="text-center">
                    <p style="text-align: center">
                      <a v-if="!otpresent" href="#" @click.prevent="resendOTP()"
                        >Resend OTP?</a
                      >
                    </p>
                  </div>

                  <!-- OTP Timer -->
                  <div ref="timerRef" id="time" class="text-center">
                    <p
                      id="warning"
                      v-if="!expired || otpresent"
                      class="text-center"
                    >
                      You have {{ otpTime }} to enter your OTP
                    </p>
                  </div>

                  <!--************---If Response Messages From the Back End is either "OTP_Wrong or TempBlock"---********** -->

                  <div
                    v-if="!respMessageExpire"
                    class="text-center"
                    style="text-align: center"
                  >
                    <p
                      id="message"
                      class="text-center"
                      v-if="respMessage === 'OTP_wrong' || 'Fail'"
                    >
                      {{ message }}
                    </p>
                    <p
                      id="message"
                      class="text-center"
                      v-if="respMessage === 'TempBlock'"
                    >
                      {{ message }}
                    </p>
                  </div>
                </v-col>
              </v-row>

              <v-row justify="center">
                <v-col cols="12" class="text-center">
                  <v-btn
                    style="border-radius: 0; width: 300px; height: 30px"
                    @click="otpValidation()"
                    color="#005F95"
                    class="white--text"
                    :loading="isLoading"
                  >
                    <span v-if="!isLoading">SUBMIT</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
/* eslint-disable */
import { useDisplay } from "vuetify/lib/framework.mjs";
import { ref, onBeforeMount, computed, onMounted, nextTick } from "vue";
import { useRouter } from "vue-router";
import axios from "axios"; // Import axios if not globally available
const refNumber = sessionStorage.getItem("refNumber");
const { smAndDown, mdAndUp, lgAndUp } = useDisplay();
const isSmall = smAndDown;
const isMedium = computed(() => mdAndUp.value && !lgAndUp.value);
const product = ref("");
const router = useRouter();
const prodtype = ref(sessionStorage.getItem("prodtype"));
const maskedCell = sessionStorage.getItem("maskedCell");
const userId = sessionStorage.getItem("userid");
const otpCheck = sessionStorage.getItem("otpCheck");

const BeyondSelected = ref(false);
const txtEmailaddress = ref("");
const otp = ref(["", "", "", "", "", ""]);
const otpRefs = ref([]);
const loginOptions = ref("SMS");
const expired = ref(false);
const otpresent = ref(false);
const message = ref("");
const respMessage = ref("");
const respMessageExpire = ref(false);
const resentOTPMessage = ref("");
const respMessageFAIL = ref("OTP Invalid");
const isLoading = ref(false);

onMounted(() => {
  // Auto-focus first box when dialog opens
  nextTick(() => {
    otpRefs.value[0]?.focus();
  });
});

onBeforeMount(() => {
  // Get product type from session storage
  prodtype.value = sessionStorage.getItem("prodtype");

  const productMap = {
    platinum: "CREDIT CARD",
    shariah: "SHARI'AH CARD",
    beyond: "BEYOND CARD",
  };
  product.value = productMap[prodtype.value] || "CREDIT CARD";
  BeyondSelected.value = prodtype.value === "beyond";
  GetUserRefNumber();

  if (otpCheck) {
    //Check if the new has been sent before starting the count.
    timecreated();
  }

  //   if (refNumber) {
  //     // GetUserForReferenceNumber();
  //   } else {
  //     router.push("/");
  //   }
});

//***********************************************************************--Function OTP Functionalities--*******************************************************************
// Handle input and auto-move to next field
const handleInput = (index, event) => {
  if (event.inputType === "deleteContentBackward") return;

  if (event.target.value.match(/^\d$/)) {
    otp.value[index] = event.target.value;

    // Move to the next field
    if (index < 5) {
      nextTick(() => {
        otpRefs.value[index + 1]?.focus();
      });
    }
  } else {
    otp.value[index] = ""; // Ensure only numbers
  }
};

// Handle backspace and move to previous field
const handleBackspace = (index, event) => {
  if (!otp.value[index]) {
    if (index > 0) {
      nextTick(() => {
        otpRefs.value[index - 1]?.focus();
      });
    }
  }
};

const otpValidation = async () => {
  isLoading.value = true;
  const token = sessionStorage.getItem("authToken");

  // console.log("Login Token: ", token)

  if (!userId) {
    console.log("User not authorized");
    return;
  }

  const otpValue = otp.value.join(""); // Convert OTP array to string

  if (!otpValue || otpValue.length !== 6) {
    message.value = "Please enter a valid 6-digit OTP";
    return;
  }
  if (expired.value) {
    otpresent.value = false;
  } else {
    otpresent.value = true;
  }

  // loading.value = true;
  // error.value = false;

  try {
    const response = await axios.post(
      "/otpValidation",
      {
        _OTP: otpValue,
        _USERID: userId,
        _REFNUMBER: refNumber,
      },
      {
        headers: {
          Authorization: token,
        },
      }
    );
    const authToken =
      response.headers["authorization"] || response.headers["Authorization"];
    if (authToken) {
      sessionStorage.setItem("authToken", authToken); // Store the token in local storage
    }

    isLoading.value = false;

    if (!response.data.data) {
      router.push("/TechnicalError");
    } else {
      const responseData = response.data.data;

      if (responseData._RESPONSE === "OTP_match") {
        sessionStorage.setItem("otpauth", responseData._RESPONSE);
        router.push("/ApplicationList");
      } else if (responseData._ERRORMESSAGE === "TempBlocked") {
        message.value =
          "Your login details have been temporarily blocked, please try again after 15 minutes";
        respMessage.value = responseData._RESPONSE;
        router.push("/HomePage");
      } else {
        message.value = "Incorrect OTP, Please try again";
        isLoading.value = false;
        respMessage.value = responseData._RESPONSE;
        otpresent.value = false;
        router.push("/UserOTP");
      }
    }
  } catch (error) {
    console.error(error);
    isLoading.value = false;
    if (error == "Error: Request failed with status code 401") {
      window.location.replace("/");
    }
  }
};

//************************************************--Function to update PAQ (Pre-Agreement Quote) Status--******************************************************

const otpTime = ref("3:00"); // Initial value, 3 minutes
const timerRunning = ref(false);
const timerRef = ref(null);
let intervalId = null; // Store the interval ID

const timecreated = async () => {
  // console.log("Starting OTP Timer...");
  await nextTick(); // Ensure DOM updates
  // if (timerRef.value) {
  startTimer(180); // 3 minutes
  // } else {
  //   console.warn("Timer element not found");
  // }
};

const startTimer = (duration) => {
  if (intervalId) clearInterval(intervalId); // Stop the previous timer
  let timer = duration;
  timerRunning.value = true;

  // otpTime.value = 180; // Reset time to 3 minutes
  expired.value = false; // Reset expired status

  intervalId = setInterval(() => {
    if (!timerRunning.value) {
      clearInterval(intervalId);
      return;
    }

    let minutes = Math.floor(timer / 60);
    let seconds = timer % 60;
    otpTime.value = `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;

    if (--timer < 0) {
      expired.value = true; // Show expiration message
      // otpTime = "Expired";
      clearInterval(intervalId);
    }
  }, 1000);
};

const GetUserRefNumber = async () => {
  if (!userId && !refNumber) {
    console.log("User not authorized");
    return;
  }

  try {
    const response = await axios.post("/GetUserForReferenceNumber", {
      _REFNUMBER: refNumber,
    });

    if (response.data.data._USERID !== null) {
      console.log("User ID Retrieved Successfully");
    } else {
      console.log("Unable to Retrieved User ID");
    }
  } catch (error) {
    console.error("Error Fetching  Use ID:", error);
  }
};

const resendOTP = async () => {
  // const token = sessionStorage.getItem("authToken");

  if (!userId && !refNumber) {
    console.log("User not authorized");
    return;
  }

  try {
    const response = await axios.post(
      "/resendOTP",
      {
        _COMM_TYPE: loginOptions.value,
        _EMAIL: userId,
        _MASKEDCELL: maskedCell,
      }
      // {
      //   headers: {
      //     Authorization: token, // Passing auth token in headers
      //   },
      // }
    );

    if (response.data.data === "NEWOTPSENT") {
      console.log(`OTP has been resent to: ${maskedCell}`);
      // Restart OTP expiration countdown
      timecreated();
      otpresent.value = true; // Show resend link
      respMessage.value = true;
      resentOTPMessage.value = `OTP has been resent to: ${maskedCell}`;
      //alert(response.data.OTP)
    } else {
      respMessageExpire.value = false;
      console.log("Failed to resend OTP");
    }
  } catch (error) {
    console.error("Error resending OTP:", error);
  }
};
</script>

<style scoped>
.otp {
  background: url("../assets/images/BeyondBI.jpeg") no-repeat center center;
  background-size: cover;
  /* position: absolute;
  height: 100%;
  width: 100%; */
}

#border {
  border-top: 3px solid #000;
}

@font-face {
  font-family: "GathamLight";
  src: url("../assets/fonts/Gotham-Light.otf");
}
p {
  text-align: left;
  font-family: "GathamLight";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

@font-face {
  font-family: "GathamBookLimit";
  src: url("../assets/fonts/Gotham-Book.otf");
}
.Login-Toolbar {
  font-family: "GathamBookLimit";
  /* font-size: 10px; */
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  /* padding: 30px; */
}
#warning {
  color: #9f6000;
}

#message {
  /* align-content: center;
        text-align: center; */
  color: #d8000c;
}

@font-face {
  font-family: "GathamLight";
  src: url("@/assets/fonts/Gotham-Light.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Light.otf") format("opentype");
  font-display: swap;
}
.OTP-Tittle {
  font-family: "GathamLight";
  font-size: 17px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

label {
  font-family: "GathamLight";
  color: #041e42;
}
h1 {
  font-family: "GathamLight";
  color: #041e42;
}

h2 {
  font-family: "GathamLight";
  color: #041e42;
}
h3 {
  font-family: "GathamLight";
  color: #041e42;
}

.otp-box {
  max-width: 40px; /* Adjust width */
  height: 50px !important;
  text-align: center; /* Centers the text */
  font-size: 20px; /* Adjust text size */
  margin: 0 5px; /* Adds spacing between boxes */
  border-radius: 0 !important;
}
.clear {
  /* background-color: transparent; */
  box-shadow: none;
  margin-top: -190px;
  /* margin-left: 80px; */
}
@media (min-width: 1280px) {
  .beyond-margin {
    margin-left: 70px;
    padding-top: 230px;
  }
}
</style>
